import React, { useEffect } from 'react';
import { BrowserRouter } from "react-router-dom";
import HomeRoutes from './routes';
import { attachGlobalKeyboardHandlers } from './utils/common';
import { initUnityBridge } from './helpers/UnityBridge';


function App() {

  function handleContextMenu(e) {
    e.preventDefault();
  }
  useEffect(() => {
    const rootElement = document.getElementById('root');
    rootElement.addEventListener('contextmenu', handleContextMenu);
    const detachKeyboardHandlers = attachGlobalKeyboardHandlers();

    const handleBackButton = (event) => {
      if (window.history.state && !window.history.state.idx) {
        window.history.replaceState({}, '', '/');
      }
    };
    window.addEventListener('popstate', handleBackButton);

    initUnityBridge();

    return () => {
      rootElement.removeEventListener('contextmenu', handleContextMenu);
      window.removeEventListener('popstate', handleBackButton);
      detachKeyboardHandlers();
    };
  }, []);

  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <HomeRoutes onContextMenu={(e) => e.preventDefault()} />
    </BrowserRouter>
  );
}

export default App;
